import React from 'react';
import { popupOpenService } from '../../../services/popupOpenService';
import { POPUP_KEY_CREATE_PRODUCT } from '../../../constant';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const CreateNewProductButton = () => {
    const { i18n } = useTranslation();
    const openPopup = () => {
        popupOpenService.callToOpen(POPUP_KEY_CREATE_PRODUCT, null);
    };

    return (
        <Button variant="outline" className="product__button" onClick={openPopup}>
            {i18n.t('app.page.product.addProduct')}
        </Button>
    );
};

export default CreateNewProductButton;
